import {
  DesktopFiltersDropdown,
  DesktopFiltersToolbar,
  DesktopFilterTag,
} from "features/filters/components";

import { DropdownMenuList } from "common/components/ui/DropdownMenu";
import { typedObjectEntries } from "common/helpers/utils";
import type { SelectedFacetParam } from "common/types";

import { LIST_LEADS_FILTERS } from "../../../../constants";
import useListLeadsParams from "../../../../hooks/useListLeadsParams";
import FilterOptions from "./FilterOptions";

import type { ListLeadsFacets, ListLeadsSearchParams } from "../../../../types";

interface DesktopFiltersProps {
  searchParams: ListLeadsSearchParams<SelectedFacetParam>;
  setSearchParams: (
    searchParams: ListLeadsSearchParams<SelectedFacetParam>,
  ) => void;
  facets: ListLeadsFacets;
  isLoadingFacets: boolean;
}

export default function DesktopFilters({
  searchParams,
  setSearchParams,
  facets,
  isLoadingFacets,
}: DesktopFiltersProps) {
  const { hasFilters, resetSearchParam, resetFilters } = useListLeadsParams(
    searchParams,
    setSearchParams,
  );

  const filterOptionsProps = {
    searchParams,
    setSearchParams,
    facets,
    isLoadingFacets,
  };

  return (
    <DesktopFiltersToolbar clearAllFilters={hasFilters && resetFilters}>
      {typedObjectEntries(LIST_LEADS_FILTERS).map(([key, { icon, label }]) => {
        const selectedFiltersLabels = searchParams[key].map(({ name }) => name);

        if (!selectedFiltersLabels.length) {
          return null;
        }

        return (
          <DesktopFilterTag
            key={key}
            icon={icon}
            label={label}
            selectedFilters={selectedFiltersLabels}
            onRemove={() => resetSearchParam(key)}
          >
            <DropdownMenuList>
              <FilterOptions {...filterOptionsProps} filterKey={key} />
            </DropdownMenuList>
          </DesktopFilterTag>
        );
      })}

      <DesktopFiltersDropdown
        filters={LIST_LEADS_FILTERS}
        renderFilter={(filterKey) => (
          <FilterOptions {...filterOptionsProps} filterKey={filterKey} />
        )}
        hasFilters={hasFilters}
      />
    </DesktopFiltersToolbar>
  );
}
